// extracted by mini-css-extract-plugin
export default {"Group":"Feature_Group__iZbVA","featureText":"Feature_featureText__Yc6xs"};